<template lang="pug">
  v-container#list.pr-0(fluid)
    v-col.no-modal.pt-0(xs12)
      v-card(flat)
        v-card-text.pb-0.small.gray-medium-text.bold Busca palabras:
        v-card-title.py-0.searchbar
          v-text-field.px-3.search(
            v-model="search"
            append-icon="search"
            placeholder="Filtra los folios por palabra clave"
            hide-details
            class="input-group--focused"
          )
          v-card-actions(v-if="userPermissions.createReports")
            v-btn.add.main-background.white-text(
              fab
              @click="setCreateForm()"
            )
              v-icon(dark) add

        v-data-table.mt-4(
          :headers="headers"
          :items="filteredReportsForTable"
          :page.sync="pagination"
          @page-count="pageCount = $event"
          multi-sort
        )
          template(v-slot:item="{ item }")
            tr(@click="setRecord(item.folio)", :class="selectedFolio == item.folio ? 'selected' : ''")
              td.px-1.dark-text {{ `#${item.folio}`}}
              td.text-xs-left.px-1.dark-text {{ item.disappearanceDate }}
              td.text-xs-left.px-1.dark-text {{ item.disappearanceMun }}
              td.text-xs-left.px-1.dark-text {{ item.name }}
              td.text-xs-left.px-1.dark-text {{ item.tags }}
              td.text-xs-left.px-1.dark-text {{ item.updates }}

          v-alert(
            slot="no-results"
            :value="true"
            color="error"
            icon="warning"
          ) No se encontraron resultados.

</template>
<script>
import * as _ from "lodash";

export default {
  name: "List",
  data() {
    return {
      filteredReportsForTable: [],
      user: this.$store.state.user,
      search: "",
      pagination: 15,
      pageCount: 0,
      headers: [
        {
          text: "Folio",
          align: "left",
          value: "folio"
        },
        { text: "Fecha de desaparición", value: "disappearanceDate" },
        { text: "Municipio", value: "disappearanceMun" },
        { text: "Nombre de la víctima", value: "name" },
        { text: "Etiquetas", value: "tags" },
        { text: "Última fecha de actualización", value: "updates" }
      ],
      selectedFolio: ""
    };
  },
  computed: {
    reports() {
      return this.$store.getters.reports;
    },
    reportsForTable() {
      let reports = this.reports;
      return reports;
    },
    userPermissions() {
      return this.$store.getters.user.permission;
    }
  },
  watch: {
    reportsForTable: async function(val) {
      val.forEach(el => {
        if (el.tags && el.tags.length > 0) {
          el.tags = el.tags.map(e => e.text).join(", ");
        } else if (el.tags && el.tags.length == 0) {
          el.tags = "";
        }
      });

      this.updateDummyTable(val);
      //this.filteredReportsForTable = val;
    },
    search: async function(val) {
      val = val.toLowerCase();
      if (this.search === "") {
        //this.filteredReportsForTable = this.reportsForTable;
        this.updateDummyTable(this.reportsForTable);
      } else {
        const filteredReportsForTable = await this.reportsForTable.filter(r => {
          let joinedDisappearanceDate = `${r.victimData.disappearanceDate.day}/${r.victimData.disappearanceDate.month}/${r.victimData.disappearanceDate.year}`;
          let tags =
            r.tags && r.tags.length > 0
              ? r.tags.toLowerCase().includes(val)
              : false;
          let lastUpdate = this.formatDate(
            r.updates[r.updates.length - 1]["when"],
            "date"
          );

          return (
            r.folio.toString().includes(val) ||
            r.victimData.name.toLowerCase().includes(val) ||
            joinedDisappearanceDate.includes(val) ||
            r.victimData.disappearanceMun.toLowerCase().includes(val) ||
            lastUpdate.includes(val) ||
            tags
            /*|| Object.keys(r.synthesis.matter)
              .filter(k => r.synthesis.matter[k].isSelected)
              .map(k => r.synthesis.matter[k].text)
              .join(", ")
              .toLowerCase()
              .includes(val)*/
          );
        });

        this.updateDummyTable(filteredReportsForTable);
        //this.filteredReportsForTable = filteredReportsForTable;
      }
    }
  },
  methods: {
    updateDummyTable(array) {
      // This array is created and display on the list because displaying "filteredReportsForTable" wasn't sortable
      this.filteredReportsForTable = [];
      for (var i = 0; i < array.length; ++i) {
        var newEntry = {};
        newEntry["folio"] = array[i].folio;
        newEntry["disappearanceDate"] = this.formatDate(
          array[i].victimData.disappearanceDate,
          "string"
        );
        newEntry["disappearanceMun"] = array[i].victimData.disappearanceMun;
        newEntry["name"] = array[i].victimData.name;
        newEntry["tags"] = array[i].tags;
        newEntry["updates"] = this.formatDate(
          array[i].updates[array[i].updates.length - 1]["when"],
          "date"
        );

        this.filteredReportsForTable.push(newEntry);
      }
    },
    formatDate(value, type) {
      if (type === "date")
        return new Intl.DateTimeFormat("es").format(new Date(value));

      let month =
        value.month.length < 2 && value.month !== ""
          ? `0${value.month}`
          : value.month;
      let day =
        value.day.length < 2 && value.day !== "" ? `0${value.day}` : value.day;

      let date = day !== "" ? `${day}` : "";
      date += day !== "" && month !== "" ? "/" : "";
      date += month !== "" ? `${month}` : "";
      date += month !== "" && value.year !== "" ? "/" : "";
      date += value.year !== "" ? `${value.year}` : "";

      return date;
    },
    setCreateForm: async function() {
      this.$router.push("/form");
      /* this.$store.dispatch("initAllForms").then(() => {
        this.$store.state.editing = false;
        this.$nextTick();
        this.$router.push("/form");
      }).catch(err => console.log('initAllForms err:', err)); */
    },
    setRecord(folio) {
      var record = this.reportsForTable.find(el => el.folio == folio);
      this.selectedFolio = record.folio;
      /* if (this.user.role === "Administración" || record.public === true) {
        this.$store.dispatch("setRecord", record);
        //this.$store.state.victims = record.victims;
      } */
      this.$store.dispatch("setRecord", record);
    },
    getReports() {
      this.$store.dispatch("getAllReports");
    },
    getMatter(matters) {
      let selectedMatters = [];
      _.forEach(matters, m => {
        if (m.isSelected) {
          selectedMatters.push(m.text);
        }
      });
      return selectedMatters.join(", ");
    }
  },
  async mounted() {
    this.getReports();
  }
};
</script>
<style lang="scss" scoped>
#list {
  padding: 0px;
  .searchbar {
    height: 40px;
    .search {
      .v-icon {
        color: black;
      }
      background-color: #dadada;
      color: $font-color-dark;
      border-radius: 10px;
      font-weight: 700;
      font-size: 19px;
      height: 40px;
      padding-top: 3px;
      .input-group__input {
        input {
          font-size: 19px;
        }
        .input-group__append-icon {
          font-weight: normal !important;
        }
      }
      .input-group__details {
        display: none;
      }
      .v-input__slot::before {
        border: none;
      }
    }
  }

  .add {
    width: 39px;
    height: 39px;
  }

  label {
    margin-left: 1rem;
    font-size: 21px;
  }
}

.no-modal {
  padding: 16px !important;
}

.modal {
  padding: 0px;
}

thead th {
  padding-left: 4px !important;
  span {
    text-transform: uppercase;
    color: $font-tab-color !important;
    font-weight: 700 !important;
    font-size: 12px !important;
  }
}

.selected {
  background-color: #fcffc0;
}

.review-icon {
  width: 1px;
  height: 14px;
}

.disabled {
  //background-color: lightgrey;
  td {
    color: lightgrey !important;
  }
}

::placeholder {
  color: #212034 !important;
  opacity: 1;
  font-size: 15px;
}

/*.input-group__details{
  display: none !important;
}*/
/*
td.transparent-light {
  font-size: 12px !important;
}
*/
</style>
